export function formatPrice(number = 0, options = {}) {
    const { minimumFractionDigits = 2, isCartPrice = false } = options;

    // Ensure the input is a number and adjust it based on whether it's a cart price
    const parsedNumber = parseFloat(number);
    if (isNaN(parsedNumber)) {
        console.error('Invalid number input:', number);
        return new Intl.NumberFormat("fil-PH", {
            style: "currency",
            currency: "PHP",
            minimumFractionDigits
        }).format(0);
    }

    // If the price is from the cart, divide by 100 to convert centavos to pesos
    const adjustedNumber = isCartPrice ? parsedNumber / 100 : parsedNumber;

    return new Intl.NumberFormat("fil-PH", {
        style: "currency",
        currency: "PHP",
        minimumFractionDigits
    }).format(adjustedNumber);
}

export function inRange(num = 0, min, max) {
  return Number(num) >= Number(min) && Number(num) <= Number(max);
}

export function chunk(input, size) {
  return input.reduce((arr, item, idx) => {
    return idx % size === 0
      ? [...arr, [item]]
      : [...arr.slice(0, -1), [...arr.slice(-1)[0], item]];
  }, []);
}
